import styled from 'styled-components';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 6.5rem 2rem;

  padding: 3rem 1.5rem;
`;

export { Wrapper };
